// const baseUrl="https://admin.cleaningcrm.fluttertrends.com" // onworking


// const baseUrl="http://101.53.148.75:6079"
// https://admin.cleaningcrm.fluttertrends.com/
// const baseUrl="http://api.advancedfacilitycare.co.nz" // previously active
// const baseUrl="https://api.advancedfacilitycare.co.nz"
// const baseUrl="https://edu.malspy.com"
const baseUrl="https://back.advancedfacilitycare.co.nz";
export {baseUrl} ;
